import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type LocationQueryVariables = Types.Exact<{
  locationId: Types.Scalars['String']['input'];
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null };

export type LocationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LocationDocumentFilterInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Array<Types.LocationDocumentSortInput> | Types.LocationDocumentSortInput>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null }> | null } | null };

export type LocationDetailsFragment = { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null };

export type LocationFragment = { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null };

export type LocationDefaultContactFragment = { __typename?: 'LocationData', defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean };

export type LocationReceivingHoursFragment = { __typename?: 'LocationData', receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null };

export const LocationDetailsFragmentDoc = new TypedDocumentString(`
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
    fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"LocationDetails"});
export const LocationFragmentDoc = new TypedDocumentString(`
    fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"Location"});
export const LocationDefaultContactFragmentDoc = new TypedDocumentString(`
    fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
}
    `, {"fragmentName":"LocationDefaultContact"});
export const LocationReceivingHoursFragmentDoc = new TypedDocumentString(`
    fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
    `, {"fragmentName":"LocationReceivingHours"});
export const LocationDocument = new TypedDocumentString(`
    query location($locationId: String!) {
  location(locationId: $locationId) {
    ...LocationDetails
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const LocationsDocument = new TypedDocumentString(`
    query locations($where: LocationDocumentFilterInput, $first: Int!, $after: String, $order: [LocationDocumentSortInput!]) {
  locations(where: $where, first: $first, after: $after, order: $order) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...LocationDetails
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    location: build.query<LocationQuery, LocationQueryVariables>({
      query: (variables) => ({ document: LocationDocument, variables })
    }),
    locations: build.query<LocationsQuery, LocationsQueryVariables>({
      query: (variables) => ({ document: LocationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useLocationQuery, useLazyLocationQuery, useLocationsQuery, useLazyLocationsQuery } = injectedRtkApi;
